function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAllItems(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M6.93333 0H0.533333C0.238933 0 0 0.238933 0 0.533333V6.93333C0 7.22773 0.238933 7.46667 0.533333 7.46667H6.93333C7.22773 7.46667 7.46667 7.22773 7.46667 6.93333V0.533333C7.46667 0.238933 7.22773 0 6.93333 0ZM6.4 6.4H1.06667V1.06667H6.4V6.4ZM15.4667 0H9.06667C8.77227 0 8.53333 0.238933 8.53333 0.533333V6.93333C8.53333 7.22773 8.77227 7.46667 9.06667 7.46667H15.4667C15.7611 7.46667 16 7.22773 16 6.93333V0.533333C16 0.238933 15.7611 0 15.4667 0ZM14.9333 6.4H9.6V1.06667H14.9333V6.4ZM6.93333 8.53333H0.533333C0.238933 8.53333 0 8.77227 0 9.06667V15.4667C0 15.7611 0.238933 16 0.533333 16H6.93333C7.22773 16 7.46667 15.7611 7.46667 15.4667V9.06667C7.46667 8.77227 7.22773 8.53333 6.93333 8.53333ZM6.4 14.9333H1.06667V9.6H6.4V14.9333ZM15.4667 8.53333H9.06667C8.77227 8.53333 8.53333 8.77227 8.53333 9.06667V15.4667C8.53333 15.7611 8.77227 16 9.06667 16H15.4667C15.7611 16 16 15.7611 16 15.4667V9.06667C16 8.77227 15.7611 8.53333 15.4667 8.53333ZM14.9333 14.9333H9.6V9.6H14.9333V14.9333Z",
    fill: "#828282",
    style: {
      fill: "#828282",
      fill: "color(display-p3 0.5083 0.5083 0.5083)",
      fillOpacity: 1
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAllItems);
export default __webpack_public_path__ + "static/media/allItems.b3d67d928a5190bb25ac71a44b1b129b.svg";
export { ForwardRef as ReactComponent };